var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{attrs:{"id":"inscriptions_container"}},[_c('b-row',[_c('b-col',{attrs:{"md":"12"}},[_c('div',{staticClass:"content_container"},[_c('transition',{attrs:{"name":"fade"}},[_c('TableauInscrits')],1)],1)])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }